import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  CloseButton,
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  PreContractPill,
  ProfessionInfoModalStyles,
  RightSide,
  TextContainer,
  TitleBox,
} from './ProfessionInfoModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import preventiveIcon from '../../../../assets/redesign_icons/preventivo-icon.svg';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import { downloadResourceDocs } from '../../../../services/axios-client/axeCommons';
import { weBindInfo } from '../../../constants/weBindInfo';
import axe from '../../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../../services/axios-client/axeHelpers';

function ProfessionWeBindModal({
  setShowModal,
  docs,
  set_informativi,
  profession,
  userData,
}) {
  const [informations, setInformations] = useState(null);

  const closeModal = () => {
    setShowModal(false);
  };

  const downloadModuloDiProposta = async () => {
    const res = await axe.get(
      `/quotations/${userData.id}/modulo-di-proposta/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  useEffect(() => {
    const info = weBindInfo.find((el) => el.profession_code.includes(profession.profession_code));

    if (info !== undefined) {
      setInformations(info.information);
    }
  }, [profession]);

  if (informations === null) {
    return null;
  }

  return (
    <ProfessionInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>
          <RightSide>
            {docs[profession.profession] !== '' && (
              <PreContractPill
                onClick={() => downloadModuloDiProposta()}
                title={`${docs[profession.profession]}`}
              >
                <img src={preventiveIcon} alt="" />
                <p>Questionario</p>
              </PreContractPill>
            )}
            {set_informativi[profession.profession] !== '' && (
              <PreContractPill
                onClick={() => downloadResourceDocs(41, profession.profession)}
                title={`${set_informativi[profession.profession]}`}
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </PreContractPill>
            )}
          </RightSide>
          <CloseButton onClick={() => closeModal()} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <div dangerouslySetInnerHTML={{ __html: informations }} />
        </ModalContent>
      </ModalBody>
    </ProfessionInfoModalStyles>
  );
}

export default ProfessionWeBindModal;
